import { render, staticRenderFns } from "./UnRegisteredEHubsList.vue?vue&type=template&id=1c96b890&scoped=true"
import script from "./UnRegisteredEHubsList.vue?vue&type=script&lang=js"
export * from "./UnRegisteredEHubsList.vue?vue&type=script&lang=js"
import style0 from "./UnRegisteredEHubsList.vue?vue&type=style&index=0&id=1c96b890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c96b890",
  null
  
)

export default component.exports